import { render, staticRenderFns } from "./LatestNewsLink.vue?vue&type=template&id=5cdeeb32&scoped=true&"
import script from "./LatestNewsLink.vue?vue&type=script&lang=js&"
export * from "./LatestNewsLink.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsLink.vue?vue&type=style&index=0&id=5cdeeb32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdeeb32",
  null
  
)

export default component.exports